export default class Navbar {
    constructor() {
        this.el = $('.navbar-collapse');

        if (!this.el.length) {
            return false;
        }
        document.addEventListener('keydown', this.handleEscape.bind(this));

    }
    handleEscape(event) {
        if (event.key === 'Escape') {
            this.el.removeClass("show");
        }
    }

}